import { constructMap } from '../libs';
import List from './List';

class ListMap extends List {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super(args);
    this.itemMap = constructMap(data);
  }

  /**
   * Grab an item from the map by key.
   */
  item(key) {
    if (key === undefined) {
      throw new Error('Usage: Key is required.');
    }

    return this.itemMap[key];
  }

  removeItem(key) {
    super.removeItem(key);
    this.itemMap = constructMap(this.itemList);

    return this;
  }

  removeAllItems() {
    super.removeAllItems();
    this.itemMap = constructMap(this.itemList);

    return this;
  }

  constructItem(key) {
    throw new Error('Must be overridden.');
  }

  /** Attempts to add an item to the end of the list.
   *  NOTE: This will overwrite an existing item if the key already exists in the list.
   */
  pushItem(key, value) {
    const item = super.pushItem(key, value);
    this.itemMap = constructMap(this.itemList);
    return item;
  }

  addItemAtIndex(key, value, index) {
    const item = super.addItemAtIndex(key, value, index);
    this.itemMap = constructMap(this.itemList);
    return item;
  }

  unshiftItem(key, value) {
    const item = super.unshiftItem(key, value);
    this.itemMap = constructMap(this.itemList);
    return item;
  }

  merge(otherList) {
    if (!this.shouldMerge(otherList)) {
      return;
    }

    if (!otherList) return;

    super.merge(otherList);

    const ids = this.list({ ignoreFilters: true }).map(v => v.id());
    const existingItems = otherList.list({ ignoreFilters: true })
      .filter(v => v.id() !== undefined)
      .filter(v => ids.includes(v.id()));

    for (let i = 0; i < existingItems.length; i++) {
      this.itemMap[existingItems[i].id()].merge(existingItems[i]);
    }

    return this;
  }

  map() {
    return this.itemMap;
  }
}

export default ListMap;
